export function schema_chatgpt_train() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			column_result: {
				type: "string",
				title: "Colonne de résultats",
				default: "result",
			},
			column_error: {
				type: "string",
				title: "Colonne de erreurs",
				default: "error",
			},
			column_system: {
				type: "string",
				title: "Colonne du rôle donné à ChatGPT"
			},
			column_user: {
				type: "string",
				title: "Colonne du prompt"
			},
			column_assistant: {
				type: "string",
				title: "Colonne du résultat attendu en sortie"
			},
			suffix: {
				type: "string",
				title: "Nom du modèle - 18 caractères maximum"
			},
			model: {
				type: "string",
				title: "Modèle de départ (ex: gpt-3.5-turbo, gpt-4o-2024-08-06)"
			}
		},
	};
}
